import React from 'react'
import { useUpdateAppointment } from '../../../entities/appointment'
import { formatDateDDMMYYYY } from '../../../shared/helpers/date'

interface PendingEdit {
  appointmentId: string
  newAnfahrtStartIso: string
}

interface Props {
  pendingEdit: PendingEdit
  onSaved: () => void
  onCancel: () => void
}

const formatTime = (iso: string): string => {
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export const EditAppointmentPanel: React.FC<Props> = ({ pendingEdit, onSaved, onCancel }) => {
  const { mutateAsync, isPending } = useUpdateAppointment()

  const handleSave = async () => {
    await mutateAsync({
      id: pendingEdit.appointmentId,
      dto: { plannedStart: pendingEdit.newAnfahrtStartIso },
    })
    onSaved()
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between bg-white border-t border-slate-200 shadow-lg px-8 py-4">
      <p className="font-['Roboto'] text-[15px] text-[#16499A]">
        Neuer Termin:{' '}
        <span className="font-semibold">
          {formatDateDDMMYYYY(pendingEdit.newAnfahrtStartIso)} {formatTime(pendingEdit.newAnfahrtStartIso)}
        </span>
      </p>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={isPending}
          className="px-5 py-2.5 rounded-[40px] border border-slate-300 text-slate-600 font-['Roboto'] text-[15px] font-medium hover:bg-slate-50 transition-colors disabled:opacity-50"
        >
          Abbrechen
        </button>
        <button
          type="button"
          onClick={handleSave}
          disabled={isPending}
          className="px-5 py-2.5 rounded-[40px] bg-[#124093] text-white font-['Roboto'] text-[15px] font-medium hover:brightness-110 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isPending ? 'Speichern...' : 'Speichern'}
        </button>
      </div>
    </div>
  )
}
